import { apiClient } from '../client';

export interface Country {
  id: number;
  code: string;
  name: string;
}

export const countriesApi = {
  async list(): Promise<Country[]> {
    const { data } = await apiClient.get<Country[]>('/countries');
    return data;
  },
};
